import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f856af4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-invest-wrap" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = { class: "company-invest-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "company-invest-hd" }
const _hoisted_6 = {
  key: 0,
  class: "company-invest-status status3"
}
const _hoisted_7 = { class: "company-invest-label" }
const _hoisted_8 = {
  key: 1,
  class: "company-invest-status status4"
}
const _hoisted_9 = { class: "company-invest-label" }
const _hoisted_10 = {
  key: 2,
  class: "company-invest-status status5"
}
const _hoisted_11 = { class: "company-invest-label" }
const _hoisted_12 = {
  key: 3,
  class: "company-invest-status status6"
}
const _hoisted_13 = { class: "company-invest-label" }
const _hoisted_14 = { class: "company-invest-info" }
const _hoisted_15 = { class: "company-invest-title" }
const _hoisted_16 = { class: "company-invest-info-time" }
const _hoisted_17 = { class: "company-invest-info-address" }
const _hoisted_18 = { style: {"color":"#409eff"} }
const _hoisted_19 = { class: "company-invest-name" }
const _hoisted_20 = { class: "load-more" }

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import Bottom from "../components/bottom.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
const loading = ref(true);
const remainCount = ref(0)

var id = router.currentRoute.value.params.id;

const bindData = reactive({
  statusOptions: [
    {
      value: '',
      label: '全部状态',
    },
    {
      value: '3',
      label: '即将开始',
    },
    {
      value: '4',
      label: '报名中',
    },
    {
      value: '5',
      label: '已开始',
    },
    {
      value: '6',
      label: '已结束',
    },
  ],
  pageParams: {
    curPage: 1,
    pageSize: 9,
    filtrate: {
      companyCode: id,
      status: "",
      keyword: "",
      type: "2",
      projectId: ''
    },
  },
  pageResult: {
    status: 2000,
    msg: "成功",
    result: [],
    totalCount: 0,
  },
  projects: []
});

const searchEvent = (isAppend: boolean) => {
  loading.value = true;
  store
    .dispatch("frontCompanyModule/pageActivityList", bindData.pageParams)
    .then(
      (data) => {
        console.log(data);
        //成功
        for (var index in data.result) {
          const obj = data.result[index];
          switch (obj.status) {
            // case 1:
            //   obj.statusName = "草稿";
            //   break;
            // case 2:
            //   obj.statusName = "待审核";
            //   break;
            case 3:
              obj.statusName = "即将开始";
              break;
            case 4:
              obj.statusName = "报名中";
              break;
            case 5:
              obj.statusName = "已开始";
              break;
            case 6:
              obj.statusName = "已结束";
              break;
            // case 7:
            //   obj.statusName = "已取消";
            //   break;
            default:
              obj.statusName = "--";
              break;
          }
        }

        if (isAppend) {
          data.result = bindData.pageResult.result.concat(data.result);
        }
        bindData.pageResult = data;
        remainCount.value = data.totalCount - bindData.pageResult.result.length;
        loading.value = false;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const projectEvent = () => {
  store
    .dispatch("frontCompanyModule/listProject", { companyCode: id })
    .then(
      (data) => {
        bindData.projects = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

projectEvent();

searchEvent(false);

const loadPageDataEvent = () => {
  if (bindData.pageParams.curPage * bindData.pageParams.pageSize < bindData.pageResult.totalCount) {
    bindData.pageParams.curPage = bindData.pageParams.curPage + 1;
    searchEvent(true);
  }
};

const handleToDetail = (item: any) => {
  router.push('/frontDesk/bbsList/bbsDetail/' + item.id)
}


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_clock = _resolveComponent("clock")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_location = _resolveComponent("location")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, { class: "company-invest-search" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { class: "company-invest-search-text" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _unref(bindData).pageParams.filtrate.projectId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).pageParams.filtrate.projectId) = $event)),
                size: "large",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (searchEvent(false))),
                placeholder: "请选择项目"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "全部项目",
                    value: ""
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).projects, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { class: "company-invest-search-text" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _unref(bindData).pageParams.filtrate.status,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).pageParams.filtrate.status) = $event)),
                size: "large",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (searchEvent(false))),
                placeholder: "请选择状态"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).statusOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { class: "company-invest-search-text" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).pageParams.filtrate.keyword,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).pageParams.filtrate.keyword) = $event)),
                modelModifiers: { trim: true },
                onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (searchEvent(false)), ["enter"])),
                placeholder: "请输入关键字搜索",
                size: "large"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { class: "company-invest-search-btn" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElButton), {
                type: "primary",
                size: "large",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (searchEvent(false)))
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).pageResult.result, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "company-invest-item",
            key: item.id,
            onClick: () => handleToDetail(item)
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_carousel, {
                class: "bbs-detail-ad",
                height: "200px"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imageList, (image) => {
                    return (_openBlock(), _createBlock(_component_el_carousel_item, {
                      key: image.id,
                      style: {"display":"flex","justify-content":"center"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_image, {
                          class: "company-invest-banner",
                          mode: "widthfix",
                          src: image.thumbnailUrl
                        }, null, 8, ["src"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1024),
              (item.status == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.statusName || "--"), 1)
                  ]))
                : (item.status == 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(item.statusName || "--"), 1)
                    ]))
                  : (item.status == 5)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(item.statusName || "--"), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(item.statusName || "--"), 1)
                      ]))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(item.name || "--"), 1),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_el_icon, { style: {"margin-right":"5px","font-size":"16px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_clock)
                  ]),
                  _: 1
                }),
                _createTextVNode(_toDisplayString(item.pushTime), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_el_icon, { style: {"margin-right":"4px","font-size":"18px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_location)
                  ]),
                  _: 1
                }),
                _createElementVNode("span", _hoisted_18, _toDisplayString(item.province) + "，" + _toDisplayString(item.city) + "，" + _toDisplayString(item.area) + "，" + _toDisplayString(item.address), 1)
              ]),
              _createElementVNode("div", _hoisted_19, _toDisplayString(item.projectName || "--") + " | " + _toDisplayString(item.companyName || "--"), 1)
            ])
          ], 8, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_20, [
        (_unref(bindData).pageResult.result.length < _unref(bindData).pageResult.totalCount)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 0,
              class: "load-more-button",
              type: "text",
              size: "large",
              onClick: loadPageDataEvent
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 加载更多..." + _toDisplayString(remainCount.value), 1),
                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowDownBold)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(Bottom, { class: "company-invest-bottom" })
  ]))
}
}

})